import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useContent, useServices } from "../hooks/useContent";
import { imageUrls } from "../lib/supabase";

const OurServices = () => {
  // Dynamic content from Supabase
  const { content: sectionTitle } = useContent(
    "services_section_title",
    "home",
    "Serviciile noastre"
  );
  const { content: ctaButtonText } = useContent(
    "services_cta_button",
    "home",
    "Vezi toate serviciile și prețurile"
  );
  const { services, loading, error } = useServices();

  // Fallback data with Supabase URLs
  const fallbackServices = [
    {
      id: 1,
      title: "Consultații medicale",
      description: "Consultații de medicină generală și de specialitate pentru toate vârstele.",
      image_url: imageUrls.consult(),
    },
    {
      id: 2,
      title: "Fișă auto",
      description: "Evaluări medicale complete pentru obținerea permisului de conducere.",
      image_url: imageUrls.fisaAuto(),
    },
    {
      id: 3,
      title: "Pulsoximetrie",
      description: "Monitorizarea saturației de oxigen în sânge prin metode non-invazive.",
      image_url: imageUrls.pulsoximetrie(),
    },
    {
      id: 4,
      title: "Apnee de somn",
      description: "Diagnosticarea și tratamentul tulburărilor respiratorii în timpul somnului.",
      image_url: imageUrls.apnee(),
    },
    {
      id: 5,
      title: "Spirometrie",
      description: "Testarea funcției pulmonare pentru diagnosticarea afecțiunilor respiratorii.",
      image_url: imageUrls.spirometrie(),
    },
    {
      id: 6,
      title: "Masaj terapeutic",
      description: "Terapii de masaj pentru relaxare și recuperare musculară.",
      image_url: imageUrls.masaj(),
    },
  ];

  // Use services from Supabase if available, otherwise use fallback
  // Show loading state or fallback only if there's an error or no services loaded
  const displayServices = !loading && services.length > 0 
    ? services.slice(0, 6) 
    : (!loading && error) || services.length === 0 
      ? fallbackServices 
      : [];

  if (loading) {
    return (
      <section className="section services-section" id="services-wrapper">
        <div className="container">
          <h2 className="section-title">{sectionTitle}</h2>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Se încarcă serviciile...</span>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section
      className="section services-section"
      id="our-services"
    >
      <div className="container">
        <h2 className="section-title">{sectionTitle}</h2>

        <div className="row g-4">
          {displayServices.map((service, index) => (
            <div className="col-lg-4 col-md-6 col-sm-12" key={service.id}>
              <div className="service-card">
                <div className="service-img-container">
                  <img
                    src={service.image_url}
                    alt={service.title}
                    className="service-img"
                  />
                </div>
                <div className="service-content">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5">
          <Link to="/prețuri" className="btn btn-primary">
            {ctaButtonText}
            <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default OurServices;
